class Member {
  public id: number;

  public email: string = '';

  public phone: string = '';

  public nameFirst: string = '';

  public nameLast: string = '';

  public password: string = '';

  public profile: string | null;

  public token: string;

  public isSystemAdmin?: boolean;

  public isMailable: boolean;

  public activityChecked: number;

  public archived: boolean;
}

export default Member;



// WEBPACK FOOTER //
// ./src/entities/Member.ts